import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import { buttonProps } from './button.utils';

@Component({
  selector: 'cohrex-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ButtonComponent implements OnInit, OnChanges {
  props: string = '';

  private _color?: string = 'primary';
  @Input()
  set color(value: string | undefined) {
    this._color = value;
  }
  get color(): string | undefined {
    return this._color;
  }

  private _disabled?: boolean = false;
  @Input()
  set disabled(value: boolean | undefined) {
    this._disabled = value;
  }
  get disabled(): boolean | undefined {
    return this._disabled;
  }

  private _small?: boolean = false;
  spinnerSize: string = 'fa-lg';
  @Input()
  set small(value: boolean | undefined) {
    this._small = value;
    this.spinnerSize = value ? 'fa-sm' : this.spinnerSize;
  }
  get small(): boolean | undefined {
    return this._small;
  }

  private _loading?: boolean = false;
  @Input()
  set loading(value: boolean | undefined) {
    this._loading = value;
  }
  get loading(): boolean | undefined {
    return this._loading;
  }

  private _rounded?: boolean = false;
  @Input()
  set rounded(value: boolean | undefined) {
    this._rounded = value;
  }
  get rounded(): boolean | undefined {
    return this._rounded;
  }

  private _startIcon?: string;
  @Input()
  set startIcon(value: string | undefined) {
    this._startIcon = value;
  }
  get startIcon(): string | undefined {
    return this._startIcon;
  }

  private _endIcon?: string;
  @Input()
  set endIcon(value: string | undefined) {
    this._endIcon = value;
  }
  get endIcon(): string | undefined {
    return this._endIcon;
  }

  private _linkTo?: string = '/';
  @Input()
  set linkTo(value: string | undefined) {
    this._linkTo = value;
  }
  get linkTo(): string | undefined {
    return this._linkTo;
  }

  @Input() type: string = 'button';
  @Input() full: boolean = false;
  @Input() content!: string;
  @Input() className: string = '';

  @Output()
  clicked = new EventEmitter<Event>();

  ngOnInit(): void {
    this.initProps();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initProps();
  }

  initProps() {
    this.props = buttonProps({
      color: this.color,
      disabled: this.disabled,
      rounded: this.rounded,
      small: this.small
    })?.toString();
  }

  handleOnClick(event: Event) {
    this.clicked.emit(event);
  }
}
